import React from 'react';
import { connect } from 'react-redux';
import {
  submitFormCreate,
  submitFormCreateAllOutlets,
  submitFormUpdate,
} from 'actions/library/tax';
import * as clevertapLibraryTax from 'clevertap/library/tax';
import styles from './style.css';
import TaxForm from './TaxForm';

class TaxDetail extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <TaxForm onSubmit={this._onSubmit} />
      </div>
    );
  }

  _onSubmit = values => {
    const { dispatch, taxes, taxDetail } = this.props;
    if (values.action === 'save') {
      delete values.action;
      if (values.id) {
        clevertapLibraryTax.libraryUpdateOneOutlet({
          oldTax: taxDetail,
          newTax: values,
        });
        dispatch(submitFormUpdate(values.id, values, taxes));
      } else {
        clevertapLibraryTax.libraryCreateTax({
          tax: values,
          isAllOutlet: false,
        });
        dispatch(submitFormCreate(values, taxes));
      }
    } else {
      delete values.action;
      clevertapLibraryTax.libraryCreateTax({ tax: values, isAllOutlet: true });
      dispatch(submitFormCreateAllOutlets(values, taxes));
    }
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  const { taxes, taxDetail } = state.library.tax;
  return {
    taxes,
    taxDetail,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaxDetail);
